<template>
    <!--DESKTOP MOBILE TABLET-->
    <div class="all ">
        <!--Titre desktop-->
         <p class=" TitrePresta is-size-3 is-hidden-touch" style="margin-top:7%; padding-top:3%;" > NOS PRESTATIONS &nbsp; :</p>
        <!--Titre mobile-->
          <p class=" TitrePresta is-size-5 is-hidden-desktop" style="padding-top:18%; margin-bottom:5%;" > NOS PRESTATIONS &nbsp; :</p>
            <!--Colonnes-->
            <div class="columns  is-centered" style=" padding-top:4%;">
            <!--Colonne 1 -->
            <div class="column ">
                <!--Colonne 1 : contient l'image -->
                <div class="container">           
                <img  class="image" src="../../public/assets/img/Presta1.png" />
                <!--Colonne 1 : contient le survol -->
                    <div class="overlay">
                    
                        <div class="text is-hidden-touch">
                            <ul >
                                <li>Pilotage de projet</li>
                                <li>Assistance à MOA et MOE</li>
                                <li>Architecture des SI</li>
                                <li>Modélisation de données</li>
                                <li>Conception</li>
                            </ul>
                        </div>
                         
                        <div class="text is-hidden-desktop" style="font-size:9px;">
                            <ul >
                                <li>Pilotage de projet</li>
                                <li>Assistance à MOA et MOE</li>
                                <li>Architecture des SI</li>
                                <li>Modélisation de données</li>
                                <li>Conception</li>
                            </ul>
                        </div>
                    </div>
            
            </div>
            <!--Colonne 1 : Titre du conteneur -->
           <p class="TitreConteneur is-size-4-desktop is-size-6-mobile"  > Conseil en SI </p>
            </div>

                <!--Colonne 2 -->
                <div class="column ">
                <!--Colonne 2 : contient l'image' -->
                <div class="container">
                <img  class="image" src="../../public/assets/img/Presta2.png" />
                <!--Colonne 2 : contient le survol -->
                    <div class="overlay">
                
                        <div class="text is-hidden-touch">
                            <ul >
                                <li>Audit</li>
                                <li>réalisation</li>
                                <li>recette</li>
                                <li>conception </li>
                                <li>Déploiement</li>
                            </ul>
                        </div>
                         
                        <div class="text is-hidden-desktop" style="font-size:9px;">
                            <ul >
                                <li>Audit</li>
                                <li>réalisation</li>
                                <li>recette</li>
                                <li>conception </li>
                                <li>Déploiement</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <!--Colonne 2 : Titre du conteneur -->
                <p class="TitreConteneur is-size-4-desktop is-size-6-mobile" > Conseils et intégration SAP </p>
                </div>

                <!--Colonne 3 -->
                <div class="column ">
                <!--Colonne 3 : contient l'image' -->
                <div class="container">                
                <img  class="image" src="../../public/assets/img/Presta3.png" />
                <!--Colonne 3 : contient le survol -->
                    <div class="overlay">
                    

                         <div class="text is-hidden-touch">
                            <ul  style="margin-top:8%;">
                                <li>PC Soft</li>
                                <li>ABAP</li>
                                <li>C#</li>
                                <li>Angular </li>
                                <li>Node JS</li>
                                <li>Maintenance</li>
                                <li>Interfaçage SAP</li>
                                
                            </ul>
                        </div>
                         
                        <div class="text is-hidden-desktop" style="font-size:9px;">
                            <ul style="margin-top:8%;">
                                <li>PC Soft</li>
                                <li>ABAP</li>
                                <li>C#</li>
                                <li>Angular </li>
                                <li>Node JS</li>
                                <li>Maintenance </li>
                                <li>Interfaçage SAP</li>
                              
                            </ul>
                        </div>
                        
                    </div>                  
                </div>
                <!--Colonne 3 : Titre du conteneur -->
                <p class="TitreConteneur is-size-4-desktop is-size-6-mobile" > Développement sur mesure </p>
            </div>
            
        </div>
    
      <!--DESKTOP-->
      <!-- colonnes -->
        <div class="columns is-hidden-touch" style="margin-top:10%;">
            <!-- colonne 1 : gauche -->
            <div class="column " style=" border-right: 2px solid #583D6A;padding-right:1%;  ">
                <div class="ColonneGauche" >
                    <!-- colonne 1 : surligner -->
                    <img src="../../public/assets/img/box.png" class="Surligner" alt=""  />
                    <!-- colonne 1 : Titre -->
                    <p class="TitreGauche is-size-3" >COMPETENCES METIERS SAP</p>
                </div>    
                <div class="ColonneGauche" style=" margin-top:28%;">
                    <!-- colonne 1 : numéro 2 -->
                    <img src="../../public/assets/img/deux.png"   style="float:right; width:11%;margin-left:2%;" alt="" /> 
                     <!-- colonne 1 : Box numéro 2 -->
                    <div class="box" style="width:600px;float:right; padding-top:3%; padding-bottom:3 %; background-color:#F0EFF1; border-radius:10px;">  
                        <!--Box : Titre -->
                        <p   class= "Titre is-size-4">Gestion ressources humaines et management </p>
                        <!--Box : SousTitre -->
                        <p class= "SousTitre is-size-5"> Direction, animation d’équipe comptant jusqu’à 140 personnes, formation et mise en œuvre de méthodologie de travail favorisant l’efficacité et l’esprit d’équipe…</p>
                    </div>
                </div>
                <div class="ColonneGauche" style=" margin-top:75%;">

                    <img src="../../public/assets/img/quatre.png" style="float:right; width:13%;margin-left:1.5%;"    alt="" /> 
                     <div class="box" style="width:600px;float:right; padding-top:3%; padding-bottom:3 %; background-color:#F0EFF1; border-radius:10px;">  
                        <!--Box : Titre -->
                        <p   class= "Titre is-size-4">Méthodes / qualité / conseil / audits </p>
                        <!--Box : SousTitre -->
                        <p class= "SousTitre is-size-5"> Rédaction de documents méthodologiques, analyse de la valeur,...</p>
                    </div>
                </div> 
                 <div class="ColonneGauche" style=" margin-top:123%;">

                    <img src="../../public/assets/img/six.png" style="float:right; width:13%;margin-left:1.5%;"    alt="" /> 
                     <div class="box" style="width:600px;float:right; padding-top:3%; padding-bottom:3 %; background-color:#F0EFF1; border-radius:10px;">  
                        <!--Box : Titre -->
                        <p   class= "Titre is-size-4">Expertise</p>
                        <!--Box : SousTitre -->
                        <p class= "SousTitre is-size-5">Dans les domaines achats, logistique et commercial, y compris les interations avec les domaines financiers.</p>
                    </div>
                </div> 
    
            </div>
            <!-- colonne 2 : droite -->
            <div class="column is-half" style="padding-top:3%;margin-left:0.5%; border-left: 2px  dashed #583D6A; ">
      
                <div class="droite">
                    <!-- colonne 2 : numéro 1 -->
                        <img src="../../public/assets/img/un.png"  style="float:left;" alt="" />
                         <!-- colonne 2 : Box numéro 1 -->
                        <div class="box" style="float:left;width:510px; margin-left:2%; padding-bottom:5%; background-color:#F0EFF1; border-radius:10px;">
                            <!--Box : Titre -->
                            <p  class= "Titre is-size-4">Modélisation et optimisation des processus </p>
                             <!--Box : SousTitre -->
                            <p class= "SousTitre is-size-5"> Tant au niveau métier qu’administratif.</p>
                        </div>
                </div>

                <div class="droite" style=" margin-top:45%;">
                     <!-- colonne 2 : numéro 3 -->
                    <img src="../../public/assets/img/trois.png"  style="float:left;" alt="" />
                     <!-- colonne 2 : Box numéro 3 -->
                    <div class="box" style="float:left;width:510px; margin-left:2%; padding-bottom:5%; background-color:#F0EFF1; border-radius:10px;">
                         <!--Box : Titre -->
                        <p class= "Titre is-size-4" >Direction de centres de profits </p>
                         <!--Box : SousTitre -->
                        <p class= "SousTitre is-size-5" >  Contrôle et optimisation des coûts, reporting périodique, analyses des résultats, …</p>
                    </div>
                </div>

                 <div class="droite" style=" margin-top:90%;">
                     <!-- colonne 2 : numéro 3 -->
                    <img src="../../public/assets/img/cinq.png"  style="float:left;width:13%;" alt="" />
                     <!-- colonne 2 : Box numéro 3 -->
                    <div class="box" style="float:left;width:510px; margin-left:1.5%; padding-bottom:5%; background-color:#F0EFF1; border-radius:10px;">
                         <!--Box : Titre -->
                        <p class= "Titre is-size-4" >Conduite et suivi de projets</p>
                         <!--Box : SousTitre -->
                        <p class= "SousTitre is-size-5" > Construction budgétaire, analyse de riques, planification, suivi des budgets, des délivrables, management et coordination des équipes, assistance à maitrise d'ouvrage.</p>
                    </div>
                </div>
            </div>
        
        </div>
        
        <!--MOBILE TABLET -->
        <div class="is-hidden-desktop">
        <hr>
         <!-- Titre -->
        <p class="is-size-6" style="font-family: 'Courier Prime', monospace;margin-top:20%; margin-bottom:10%;">COMPETENCES METIERS SAP</p>
        <div>
        <!--  numéro 1 -->
        <img src="../../public/assets/img/un.png" style="float:left;width:15%;" alt="" />
        <!-- Box numéro 1 -->
        <div class="box" style=" margin-left:20%;">
            <!--Box : Titre -->
            <p class= "Titre is-size-6" >Modélisation et optimisation des processus </p>
            <!--Box : SousTitre -->
            <p class= " SousTitre is-size-7" > Tant au niveau métier qu’administratif.</p>
        </div>

        <!--  numéro 2 -->
        <img src="../../public/assets/img/deux.png"  style="float:right;width:15%;" alt="" />
          <!-- Box numéro 2 -->
        <div class="box " style=" margin-left:3%;" > 
            <!--Box : Titre --> 
            <p  class= "Titre is-size-6" >Gestion ressources humaines et management </p>
            <!--Box : SousTitre -->
            <p  class= " SousTitre is-size-7"> Direction, animation d’équipe comptant jusqu’à 140 personnes, formation et mise en œuvre de méthodologie de travail favorisant l’efficacité et l’esprit d’équipe…</p>
        </div>

        <!--  numéro 3 -->
        <img src="../../public/assets/img/trois.png"  style="float:left;width:15%;" alt="" />
          <!-- Box numéro 3 -->
        <div class="box" style=" margin-left:20%;" >
            <!--Box : Titre -->
            <p  class= "Titre is-size-6" >Direction de centres de profits </p>
            <!--Box : SousTitre -->
            <p  class= "SousTitre is-size-7">   Contrôle et optimisation des coûts, reporting périodique, analyses des résultats, …</p>
        </div>

         <img src="../../public/assets/img/quatre.png"  style="float:right;width:21%;" alt="" />
          <!-- Box numéro 4 -->
        <div class="box" style=" margin-left:3%;" >
            <!--Box : Titre -->
            <p  class= "Titre is-size-6" >Méthodes / qualité / conseil / audits </p>
            <!--Box : SousTitre -->
            <p  class= "SousTitre is-size-7"> Rédaction de documents méthodologiques, analyse de la valeur,...</p>
        </div>

         <img src="../../public/assets/img/cinq.png"  style="float:left;width:21%;" alt="" />
          <!-- Box numéro 5 -->
        <div class="box" style=" margin-left:22%;" >
            <!--Box : Titre -->
            <p  class= "Titre is-size-6" >Conduite et suivi de projets</p>
            <!--Box : SousTitre -->
            <p  class= "SousTitre is-size-7">Construction budgétaire, analyse de riques, planification, suivi des budgets, des délivrables, management et coordination des équipes, assistance à maitrise d'ouvrage.</p>
        </div>

         <img src="../../public/assets/img/six.png"  style="float:right;width:20%;" alt="" />
          <!-- Box numéro 6 -->
        <div class="box" style=" margin-left:3%;" >
            <!--Box : Titre -->
            <p  class= "Titre is-size-6" >Expertise</p>
            <!--Box : SousTitre -->
            <p  class= "SousTitre is-size-7">Dans les domaines achats, logistique et commercial, y compris les interations avec les domaines financiers.</p>
        </div>
        </div>
        </div>
  
    </div>
</template>
<script>


export default {
  name: "ServicePage",
   components: {
    
  },
};
</script>
<style scoped> 
@import url('https://fonts.googleapis.com/css2?family=Spartan:wght@600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Courier+Prime&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Lato&display=swap');



.TitreGauche{
 float:right; 
 font-family: 'Courier Prime', monospace;
 padding-right:13%; 
 position:relative;
}
.Surligner{
 position:absolute; 
 margin-left:8%; 
 margin-top:0.8%;
}
.TitreDescription{
 margin-top:12%;
}

.Description{
 margin-top:9%; 
 text-align:left; 
 width:90%;
 margin-left: auto;
 margin-right: auto;
}

.SousTitre{
margin-top:5%;
font-family: 'Lato', sans-serif; 
text-align:left;
}

.Titre{
    font-family: 'Courier Prime, monospace';
    text-align:left; 
    color:#482A5C;
}
.box{
   width:75%;
  
    padding-bottom:3%; 
    background-color:#F0EFF1; 
    border-radius:10px;
    margin-bottom:15%; 
}

img {  
 
  vertical-align:middle;
  width:10%;
}
hr{
  margin-bottom:7%;
  width:40%;
  margin-left:30%;
  border-top: 4px solid #583D6A;
}

div.vertical-line {
  border-right: 1px solid #808080;
  height: 350px;
  margin-left: auto;
  margin-right: auto;
  width:12px;
  
}
.flotte {
float:left;
}

.suivant{
    margin-top:2%;
    float:right;
    margin-right:5%;
}
.TitrePresta{
    text-align:left;
    margin-left:5%;
    font-family: 'Montserrat', sans-serif;
    font-weight: bolder;
}
button{
    margin-top: 5%;
    float:right;
    margin-right:5%;
    background-color :transparent;
    border-color: #482A5C;
    color:black;
    width:10% ;
    font-size:20px;    
    height: 5%; 
}

.button:hover {
    color:black;
    background-color:rgba(72, 42, 92, 0.5)
}

.TitreConteneur{
    font-family: 'Courier Prime', monospace;
    margin-top:5%;
}

.all{

    height: auto;
    background-color: #FAFAFA;
    padding-bottom:16%;
}


.text ul li {
    text-align: left;
    margin-left: 10%;
    margin-right: 10%;
    margin-top: 2%;

   list-style : inside;
   vertical-align: middle;
    font-size:1.1em;
}

.text ul{
margin-top:15%;
margin-bottom:10%;
 text-align:left; 
 width:105%;
 margin-left: auto;
 margin-right: auto;
     
}
.text{
    
    margin-top:10%;
    margin-right:8%;
    margin-left:8%;
    color: white;
    height: 80%;
    border-style:  dashed ;
    border-width: 1px;
    font-family: 'Spartan', sans-serif;
}

.image {
  display: block;
  width:60%;
  margin-left: 20%;
  height: auto;
  border-radius:8%;
}

.overlay {
  position: absolute;
  bottom: 0;
  left: 20%;
  top:0;
  height: auto;
  width:60%;
  opacity: 0;
  transition: .5s ease;
  background-color: #583D6A;
  border-radius: 5%;
}

.container:hover .overlay {
  opacity: 1;
}

.container:active .image {
  opacity: 1;
}


</style>